import Input, { InputProps } from "@components/form/Input";
import { UIColor } from "@lib/types/generic";
import { useState } from "react";
import { IoArrowBack, IoArrowForward } from "react-icons/io5";
import { Group, Showcase } from "./StyleGuide";

const Inputs = () => {
  const sizes = ["extra-small", "small", "medium", "large", "extra-large"] as InputProps["size"][];

  const [value, setValue] = useState("");
  const [color, setColor] = useState<UIColor>("purple");
  const [textColor, setTextColor] = useState<UIColor>("white");
  const [variant, setVariant] = useState<InputProps["variant"]>("contained");
  const [disabled, setDisabled] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [rounded, setRounded] = useState<boolean>(false);

  const props = {
    value,
    onChange: ({ value }: { value: string }) => setValue(value),
    color,
    textColor,
    variant,
    placeholder: "Placeholder",
    disabled,
    isLoading,
    rounded,
  };

  return (
    <Showcase
      title="Inputs"
      className="inputs"
      colors={[
        {
          color: color,
          label: "Color",
          onChange: setColor,
        },
        {
          color: textColor,
          label: "Text Color",
          onChange: setTextColor,
        },
      ]}
      selects={[
        {
          value: variant ?? "contained",
          optionsArray: ["contained", "outlined", "flat", "transparent"],
          label: "Variant",
          onChange: setVariant,
        },
      ]}
      checkboxes={[
        {
          value: disabled,
          label: "Disabled",
          onChange: setDisabled,
        },
        {
          value: isLoading,
          label: "Is loading",
          onChange: setIsLoading,
        },
        {
          value: rounded,
          label: "Rounded",
          onChange: setRounded,
        },
      ]}>
      {sizes.map(size => (
        <Group key={size}>
          <Input size={size} {...props} />
          <Input size={size} endIcon={<IoArrowForward />} {...props} />
          <Input size={size} startIcon={<IoArrowBack />} {...props} />
          <Input size={size} startIcon={<IoArrowBack />} endIcon={<IoArrowForward />} {...props} />
          <Input size={size} type="password" {...props} />
        </Group>
      ))}
    </Showcase>
  );
};

export default Inputs;
